"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RichTextField = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styles = require("../shared/styles");
var _ckeditor5React = require("@ckeditor/ckeditor5-react");
require("ckeditor5/build/ckeditor5-dll");
require("@ckeditor/ckeditor5-editor-classic/build/editor-classic");
require("@ckeditor/ckeditor5-editor-inline/build/editor-inline");
require("@ckeditor/ckeditor5-essentials/build/essentials");
require("@ckeditor/ckeditor5-basic-styles/build/basic-styles");
require("@ckeditor/ckeditor5-code-block/build/code-block");
require("@ckeditor/ckeditor5-autoformat/build/autoformat");
require("@ckeditor/ckeditor5-autosave/build/autosave");
require("@ckeditor/ckeditor5-block-quote/build/block-quote");
require("@ckeditor/ckeditor5-heading/build/heading");
require("@ckeditor/ckeditor5-mention/build/mention");
require("@ckeditor/ckeditor5-image/build/image");
require("@ckeditor/ckeditor5-indent/build/indent");
require("@ckeditor/ckeditor5-link/build/link");
require("@ckeditor/ckeditor5-list/build/list");
require("@ckeditor/ckeditor5-media-embed/build/media-embed.js");
require("@ckeditor/ckeditor5-paste-from-office/build/paste-from-office");
require("@ckeditor/ckeditor5-table/build/table");
var _jsxRuntime = require("react/jsx-runtime");
var plugins = [window.CKEditor5.autoformat.Autoformat, window.CKEditor5.heading.Heading, window.CKEditor5.essentials.Essentials, window.CKEditor5.basicStyles.Bold, window.CKEditor5.basicStyles.Italic, window.CKEditor5.codeBlock.CodeBlock, window.CKEditor5.blockQuote.BlockQuote, window.CKEditor5.image.Image, window.CKEditor5.image.ImageCaption, window.CKEditor5.image.ImageStyle, window.CKEditor5.image.ImageToolbar, window.CKEditor5.image.ImageUpload, window.CKEditor5.indent.Indent, window.CKEditor5.link.Link, window.CKEditor5.list.List, window.CKEditor5.mediaEmbed.MediaEmbed, window.CKEditor5.paragraph.Paragraph, window.CKEditor5.pasteFromOffice.PasteFromOffice, window.CKEditor5.table.Table, window.CKEditor5.table.TableToolbar, window.CKEditor5.mention.Mention, window.CKEditor5.autosave.Autosave, window.CKEditor5.typing.TextTransformation];
var toolbar = ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'imageUpload', 'blockQuote', 'codeBlock', 'insertTable', 'mediaEmbed', 'undo', 'redo'];
var StyledEditor = _styledComponents.default.div.withConfig({
  displayName: "RichTextField__StyledEditor",
  componentId: "sc-8fr2i7-0"
})(["width:100%;height:100%;", " color:", ";--ck-border-radius:", ";border-radius:", ";border:1px solid ", ";display:grid;", " .ck-editor__editable_inline{min-height:80px;height:100%;}.ck-blurred{overflow:hidden !important;}.ck-editor__editable{", " &::-webkit-scrollbar-track{border-radius:6px;background-color:", ";}&::-webkit-scrollbar{width:7px;background-color:", ";border-radius:6px;}&::-webkit-scrollbar-thumb{border-radius:6px;background-color:", ";}}&:hover{", "}"], _styles.font.base.regular, _styles.colors.text.primary, _styles.borderRadius.s, _styles.borderRadius.s, _styles.colors.border.primary.default, function (props) {
  return props.maxHeight && (0, _styledComponents.css)(["max-height:", ";"], function (_ref) {
    var maxHeight = _ref.maxHeight;
    return maxHeight;
  });
}, function (props) {
  return props.maxHeight && (0, _styledComponents.css)(["max-height:", ";"], function (_ref2) {
    var maxHeight = _ref2.maxHeight;
    return maxHeight;
  });
}, _styles.colors.background.secondary.default, _styles.colors.background.secondary.default, _styles.colors.background.tertiary.default, function (props) {
  return !props.disabled && (0, _styledComponents.css)(["border:1px solid ", ";"], _styles.colors.border.primary.hover);
});
var RichTextField = function RichTextField(props) {
  var config = {
    plugins: plugins,
    toolbar: toolbar,
    image: {
      toolbar: ['imageTextAlternative', 'imageStyle:inline', 'imageStyle:block', 'imageStyle:side']
    },
    table: {
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
    },
    removePlugins: props.limitations,
    placeholder: props.placeholder,
    autosave: {
      save: function save(editor) {
        // The saveData() function must return a promise
        // which should be resolved when the data is successfully saved.
        return props.onSaveHandler(editor.getData());
      }
    },
    link: {
      defaultProtocol: 'http://'
    }
  };
  var editor = props.editor === 'ClassicEditor' ? window.CKEditor5.editorClassic.ClassicEditor : window.CKEditor5.editorInline.InlineEditor;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledEditor, {
    disabled: props.disabled,
    maxHeight: props.maxHeight,
    "data-cy": props['data-cy'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ckeditor5React.CKEditor, {
      disabled: props.disabled,
      editor: editor,
      config: config,
      data: props.data,
      onBlur: function onBlur(event, editor) {
        props.onSaveHandler(editor.getData());
      }
    })
  });
};
exports.RichTextField = RichTextField;
RichTextField.defaultProps = {
  editor: 'ClassicEditor',
  limitations: [],
  placeholder: 'Add some text...',
  onSaveHandler: function onSaveHandler(data) {
    return data;
  }
};